// take our formatted properties and assign them to names Suitable for the CSV headers
// using capitals for names so they appear as capitals
import moment from 'moment';
import formatPhoneForUser from '../../../../utils/formatPhoneForUser';

const formatConversationCSV = ({ messages, users, customer }) => {
	if (
		messages &&
		messages.length === 1 &&
		messages[0] &&
		messages[0]._id === 'no_message'
	) {
		return {
			'Customer Name': customer?.name || '',
			'Customer Phone': customer?.phone
				? formatPhoneForUser(customer.phone)
				: '',
			'Date sent': '',
			Message: '',
			Sender: '',
			'Sent by': '',
			'Sent from': '',
		};
	}

	// Ensure users is defined and is an array
	const safeUsers = users && Array.isArray(users) ? users : [];

	return messages
		.filter(
			(messageToFilter) =>
				messageToFilter.sender !== 'event' ||
				!messageToFilter.active === false
		)
		.map((message) => {
			const user = safeUsers.find((u) => u._id === message._user);
			return {
				'Customer Name': customer?.name || '',
				'Customer Phone': customer?.phone
					? formatPhoneForUser(customer.phone)
					: '',
				'Date sent': moment(message.createdAt).format('LLL'),
				Message: message.media
					? `${message.text} ${message.media}`
					: message.text,
				Sender: message.sender,
				'Sent by': (user && user.username) || '',
				'Sent from': message.channel,
			};
		});
};

export default formatConversationCSV;
